import { render } from "./UserMenuPlan.vue?vue&type=template&id=79d4b977"
import script from "./UserMenuPlan.vue?vue&type=script&lang=js"
export * from "./UserMenuPlan.vue?vue&type=script&lang=js"

import "./UserMenuPlan.vue?vue&type=style&index=0&id=79d4b977&lang=scss"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__